// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RySN","title":"styles_title__60tX-"};